import _ from 'lodash'
import React, { Component } from 'react'
import UISelect from 'components/shared/UISelect'
import UserSelectionSection from 'components/UserSelectionSection'
import { userListOptions } from './Constants'
import styles from './styles.styl'
import { List } from 'immutable'

const DESCRIPTIONS = {
  DESCRIPTION_USER: 'We’ll always display this person in your default greeting.',
  DESCRIPTION_RANDOM: 'We’ll display a member of your team at random in your default greeting.',
}

function getSelectedUser(allUsers, userId) {
  return _.find(allUsers, { id: userId })
}

const toSelectOptions = (userListOptions) =>
  _.map(userListOptions.enums, (data) => ({ value: data.key, label: data.value.display }))

const UserList = ({ allUsers, userList, onSelectUser, validation }) => (
  <div className="user-list">
    <UserSelectionSection
      user={getSelectedUser(allUsers, userList.first())}
      onSelect={onSelectUser}
      enableClear={false}
    />
    {!validation.isValid ?
      <div className="dsg-Label--pink" style={{ textTransform: 'none' }}>
        {validation.invalidLabel}
      </div>
    : null}
  </div>
)

class HelpingTeamMemberSelection extends Component {

  constructor(props) {
    super(props)

    this.onUserListModeChange = this.onUserListModeChange.bind(this)
    this.onSelectUser = this.onSelectUser.bind(this)

    this.state = {
      userListMode: props.userListMode,
      userList: props.userList
    }
  }

  onUserListModeChange(userListMode) {
    this.setState({ userListMode: userListMode.value })
    this.props.onUserListModeChange(userListMode.value)
  }

  onSelectUser(userId) {
    const userList = userId !== undefined ? List.of(userId) : List()
    this.setState({ userList })
    this.props.onSelectUser(userList)
  }

  render() {
    const { allUsers, validation } = this.props
    const { userListMode, userList } = this.state

    const options = toSelectOptions(userListOptions)
    const isHandPicked = userListMode === userListOptions.CUSTOM.key
    const description = DESCRIPTIONS[isHandPicked ? 'DESCRIPTION_USER' : 'DESCRIPTION_RANDOM']

    return (
      <div className={styles.HelpingTeamMemberSelection} onFocus={_.noop}>
        <div className="top-row">
          <UISelect
            value={userListMode}
            onSelection={this.onUserListModeChange}
            options={options}
            searchable={false}
          />
          { isHandPicked &&
            <UserList
              allUsers={allUsers}
              userList={userList}
              onSelectUser={this.onSelectUser}
              validation={validation}
            />
          }
        </div>
        <div className="description">
          { description }
        </div>
      </div>
    )
  }
}

export default HelpingTeamMemberSelection



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Online/HelpingTeamMemberSelection/index.js